import { createContext } from '@wordpress/element';

// Used to track and dismiss the prior modal when another opens unless nested.

export const ModalContext = createContext(new Set());
ModalContext.displayName = 'ModalContext';